<div class="custom-form-group">
  <label *ngIf="label" class="custom-input-label" [for]="inputId"
    >{{ label }}
    @if (isRequired) {
      <span class="required-asterisk">*</span>
    }
  </label>
  <!-- Search Icon -->
  @if (showSearchIcon) {
    <div class="search-wrapper">
      <img src="assets/search.svg" alt="search" />
    </div>
  }

  <input
    [id]="inputId"
    matInput
    [type]="isPasswordVisible ? 'text' : inputType"
    [placeholder]="placeholder"
    [value]="value"
    (input)="onInputChange($event)"
    [disabled]="isDisabled"
    [ngClass]="{
      'error-border':
        formControl?.invalid &&
        (formControl?.dirty || formControl?.touched || isSubmit),
      'search-icon': showSearchIcon,
    }"
    [attr.aria-label]="placeholder"
  />

  <div class="eye-wrapper" *ngIf="inputType === 'password'">
    <img
      [src]="isPasswordVisible ? 'assets/eye.svg' : 'assets/eye_off.svg'"
      [alt]="isPasswordVisible ? 'eye' : 'eye-off'"
      (click)="togglePasswordVisibility()"
      (keydown)="onKeydown($event)"
      tabindex="0"
    />
  </div>
  @if (
    formControl?.invalid &&
    (formControl?.dirty || formControl?.touched || isSubmit)
  ) {
    @if (formControl?.hasError('pattern')) {
      <p
        class="mt-1 m-0 error-message"
        [attr.aria-label]="label + ' is invalid'"
      >
        {{ label }} is invalid
      </p>
    } @else if (formControl?.hasError('exactLength')) {
      <p
        class="mt-1 m-0 error-message"
        [attr.aria-label]="label + ' must be ' + maxLength + ' digits'"
      >
        {{ label }} must be {{ maxLength }} digits
      </p>
    } @else if (formControl?.hasError('required')) {
      <p
        class="mt-1 m-0 error-message"
        [attr.aria-label]="label + ' is required'"
      >
        {{ label }} is required
      </p>
    }
  }
</div>
